
/* @flow */

import type { Mode } from "state/view-mode";

import React, { useContext } from "react";
import { Link, NavLink } from "react-router-dom";
import { StoreInfoContext } from "entrypoint/shared";
import cn from "classnames";
import SearchMenu from "components/AppHeader/SearchMenu";
import ChevronIcon from "icons/chevron-mini.svg";
import SearchIcon from "icons/search.svg";
import Categories from "components/AppHeader/Large/Categories";
import Button from "components/Button";
import { useHideSubMenu } from "components/AppHeader/Large/SubMenu";
import useDevice from "helpers/use-device";

import { MODE } from "state/view-mode";

import styles from "./styles.scss";

type Props = {
  className?: string,
  mode: Mode,
  setMode: Mode => void,
  onCheckout: boolean,
};

const noDimModes = [MODE.NORMAL, MODE.RECRUIT, MODE.TINK];

const Shop = ({ className, mode, setMode, onCheckout }: Props): React$Node | null => {
  const toggleCategories = () => setMode(mode === MODE.CATEGORIES ? MODE.NORMAL : MODE.CATEGORIES);
  const { categories, routes } = useContext(StoreInfoContext);
  const isMobile = useDevice("lt", 802);
  const hideSubMenu = useHideSubMenu();

  if ((!isMobile && hideSubMenu) || onCheckout) {
    return null;
  }

  return (
    <div className={cn(styles.shop, "awardit-subMenu", className)}>
      <div className={styles.subContainer}>
        {routes.allProductsView && routes.allProductsView.toggle !== undefined &&
        routes.allProductsView.toggle && routes.allProductsView.title !== undefined &&
        routes.allProductsView.title && routes.allProductsView.url !== undefined &&
        routes.allProductsView.url && !isMobile && (
          <NavLink
            to={routes.allProductsView.url}
            activeClassName={styles.active}
            className={cn(
              "awardit-subMenuShopItem",
              "awardit-subMenuLink",
              styles.item
            )}
          >
            {routes.allProductsView?.title}
          </NavLink>
        )}

        <Button
          className={
            cn(
              "awardit-subMenuShopItem",
              "awardit-subMenuLink",
              styles.item,
              styles.item__categories,
              { [styles.active]: mode === MODE.CATEGORIES }
            )
          }
          aria-expanded={mode === MODE.CATEGORIES ?? "true"}
          aria-controls="categoriesOverlay"
          onClick={toggleCategories}
        >
          {(routes.categoriesView && routes.categoriesView.title) ?? ""}
          <ChevronIcon className={styles.chevron} />

          {mode === MODE.CATEGORIES &&
            <nav id="catoriesOverylay" className={styles.categories}>
              <Categories categories={categories} />
            </nav>
          }

        </Button>

        {routes.brandsView && routes.brandsView.url && routes.brandsView.title &&
          <Link
            className={
              cn(
                "awardit-subMenuShopItem",
                "awardit-subMenuLink",
                styles.item,
                styles.item__categories,
                styles.brands
              )
            }
            to={{
              pathname: routes.brandsView?.url,
            }}
          >
            {routes.brandsView?.title}
          </Link>
        }
      </div>
      {isMobile ?
        <>
          <Button
            className={
              cn(
                "awardit-subMenuShopItem",
                "awardit-subMenuLink",
                "awardit-subMenuSearchItem",
                styles.item,
                styles.item__search
              )
            }
            aria-label={routes.searchView && routes.searchView.title}
            aria-controls="searchForm"
            aria-expanded={mode === MODE.SEARCH ?? "true"}
            onClick={() => setMode(MODE.SEARCH)}
          >
            {mode !== MODE.SEARCH &&
              <SearchIcon />
            }
          </Button>
          <div
            role="search"
            className={cn("awardit-subMenuSearch", styles.search, { [styles.active]: mode === MODE.SEARCH })}
            style={{ width: mode === MODE.SEARCH ? "410px" : "0px" }}
          >
            <SearchMenu autoFocus setMode={setMode} />
          </div>
        </> :
        <span
          className={
            cn(
              styles.item,
              styles.item__search
            )
          }
        >
          <nav className={styles.search}>
            <SearchMenu />
          </nav>
        </span>
      }
      {!noDimModes.includes(mode) && isMobile &&
        <div className={styles.dim} onClick={() => setMode(MODE.NORMAL)} />
      }
    </div>
  );
};

export default Shop;
